import React, { useEffect, useState } from "react";
import RequestHandler from "../../util/RequestHandler";
import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  Drawer,
  Popconfirm,
  notification,
  Tooltip,
} from "antd";
import {
  OrderedListOutlined,
  PlusOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  EditOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import MaterialListFilter from "../Filters/MaterialListFilter";
import { ColumnHelper } from "../../util/TableHelper";
import { Link, useHistory } from "react-router-dom";
import { odata, queryHelper } from "../Filters/Helper";
import MaterialAddForm from "../Forms/MaterialAddForm";
import MaterialUpdateForm from "../Forms/MaterialUpdateForm";

const MaterialList = (props) => {
  const [options, setOptions] = useState({ pageTitle: "MALZEME LİSTESİ" });
  const [materials, setMaterials] = useState({
    data: [],
    loading: true,
    total: 0,
  });
  const [tableDataQueryOptions, setTableDataQueryOptions] = useState(
    queryHelper.getDefaultTableDataQueryOptions()
  );
  const [addFormVisibility, setAddFormVisibility] = useState(false);
  const [updateFormVisibility, setUpdateFormVisibility] = useState(false);
  const [updateFormData, setUpdateFormData] = useState({});
  const history = useHistory();

  useEffect(() => {
    setFilterValues();
    getTableData();
  }, [tableDataQueryOptions]);

  const getTableData = () => {
    setMaterials({
      ...materials,
      loading: true,
    });

    const { skip, take, filter } = tableDataQueryOptions;
    const order = "&$orderby=addDate desc";
    let query = "";
    const conditions = ["Name ne 'Diğer'"];
    if (filter) {
      conditions.push(filter);
    }

    if (conditions.length > 0) {
      query = `&$filter=${conditions.join(" and ")}`;
    }
    RequestHandler.get(
      `/Material?$count=true${query}${order}&$skip=${skip}&$top=${take}`
    ).then((response) => {
      setMaterials({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const onAddMaterialSuccess = () => {
    getTableData();
    setAddFormVisibility(false);
  };

  const handleOnClickUpdate = (record) => {
    RequestHandler.get(`/Material/GetById/${record.id}`).then((response) => {
      if (response) {
        setUpdateFormData(response);
        setUpdateFormVisibility(true);
      }
    });
  };

  const onUpdateMaterialSuccess = () => {
    getTableData();
    setUpdateFormVisibility(false);
  };

  const setFilterValues = () => {
    const filterValues = {
      ...tableDataQueryOptions.values,
      skip: tableDataQueryOptions.skip,
      take: tableDataQueryOptions.take,
      current: tableDataQueryOptions.current,
      order: tableDataQueryOptions.order,
      filter: tableDataQueryOptions.filter,
    };
    const queryString = queryHelper.getQueryFromValues(filterValues);

    history.replace({
      pathname: window.location.pathname,
      search: queryString,
    });
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "Uyarı",
      description: "Pasif olan malzemeler güncellenemez.",
    });
  };

  const columns = [
    {
      title: "Malzeme Adı",
      dataIndex: "name",
      key: "name",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Malzeme Kodu",
      dataIndex: "code",
      key: "code",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },
    {
      title: "Kategori Adı",
      dataIndex: "materialCategoryName",
      key: "materialCategoryName",
      align: "left",
      render: (text) => {
        if (!text) return "";

        return (
          <Tooltip title={text}>
            {text.substring(0, 50).length < 50
              ? text.substring(0, 50) + ""
              : text.substring(0, 50) + "..."}
          </Tooltip>
        );
      },
    },

    {
      title: "Düzenle",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        materials.total >= 1 ? (
          row.isActive ? (
            <a onClick={() => handleOnClickUpdate(row)}>
              <EditOutlined style={{ color: "orange", fontSize: "130%" }} />
            </a>
          ) : (
            <a
              onClick={() => {
                openNotificationWithIcon("warning");
              }}
              style={{
                color: "orange",
                fontSize: "130%",
                paddingBottom: "20px",
              }}
            >
              <EditOutlined />
            </a>
          )
        ) : null,
    },
    {
      title: "Durum",
      dataIndex: "id",
      align: "center",
      render: (data, row) =>
        row.isActive ? (
          <Popconfirm
            title="Pasif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "green", fontSize: "130%" }}>
              <CheckCircleOutlined />
            </a>
          </Popconfirm>
        ) : (
          <Popconfirm
            title="Aktif yapmak istiyor musunuz?"
            okText="Evet"
            cancelText="Hayır"
            onConfirm={() => handleActivePassive(data)}
          >
            <a style={{ color: "red", fontSize: "130%" }}>
              <CloseCircleOutlined />
            </a>
          </Popconfirm>
        ),
    },
    {
      title: "Sil",
      dataIndex: "id",
      width: "1%",
      render: (data, row) => (
        <Popconfirm
          title="Silmek istiyor musunuz?"
          okText="Evet"
          cancelText="Hayır"
          onConfirm={() => handleOnClickDelete(row)}
        >
          <a style={{ color: "red", fontSize: "130%" }}>
            <DeleteOutlined />
          </a>
        </Popconfirm>
      ),
    },
  ];

  const onClearTableFilter = () => {
    setTableDataQueryOptions({
      ...tableDataQueryOptions,
      skip: 0,
      current: 1,
      filter: "",
      values: {},
    });
  };

  const onFinishTableFilter = (query, values) => {
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: 0,
        current: 1,
        filter: query,
        values: values,
      };
    });
  };

  const paging = (p, filters, sorter) => {
    let orderBy = "";
    if (sorter.columnKey && sorter.order) {
      orderBy =
        "&" +
        (sorter.order === "ascend"
          ? odata.orderBy(sorter.columnKey)
          : odata.orderByDesc(sorter.columnKey));
    }
    setTableDataQueryOptions((prevState) => {
      return {
        ...prevState,
        skip: (p.current - 1) * prevState.take,
        take: p.pageSize,
        current: p.current,
      };
    });
  };

  const dataStateChange = (e) => {
    setMaterials(e);
  };

  const handleActivePassive = (id) => {
    RequestHandler.post(`/Material/ChangeStatus/${id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  const handleOnClickDelete = (row) => {
    // if (row.addUserId !== localStorage.getItem("userId") && !isEditAllowed) {
    //   openNotificationForNotAuthWithIcon("warning");
    //   return;
    // }

    RequestHandler.delete(`/Material/${row.id}`).then((response) => {
      if (response.success) {
        getTableData();
      }
    });
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <OrderedListOutlined /> {options.pageTitle}
          </p>
        </Col>
        <Col xs={24} md={12} lg={8} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            onClick={() => {
              setAddFormVisibility(true);
            }}
            style={{ marginBottom: 0 }}
          >
            <PlusOutlined /> Malzeme Ekle
          </Button>
        </Col>
      </Row>

      <MaterialListFilter
        data={tableDataQueryOptions.values}
        onClearFilter={onClearTableFilter}
        onFinishFilter={onFinishTableFilter}
        style={{ marginTop: 12, marginBottom: 12 }}
      />

      <Row>
        <Col span={24}>
          <Table
            locale={{
              emptyText: (
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Veri Yok"
                />
              ),
            }}
            style={{
              overflowX: "auto",
              maxHeight: "100%",
              width: "100%",
            }}
            columns={columns}
            onDataStateChange={dataStateChange}
            dataSource={materials.data}
            loading={materials.loading}
            pageable={true}
            onChange={paging}
            pagination={{
              defaultPageSize: tableDataQueryOptions.take,
              pageSizeOptions: ["15", "25", "50", "100"],
              total: materials.total,
              current: tableDataQueryOptions.current,
            }}
            sortable={true}
            rowKey="id"
          ></Table>
        </Col>
      </Row>
      <Drawer
        id="addMaterialDrawer"
        title="Malzeme Ekle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setAddFormVisibility(false)}
        visible={addFormVisibility}
      >
        <MaterialAddForm onSuccess={onAddMaterialSuccess} />
      </Drawer>

      <Drawer
        id="updateMaterialDrawer"
        title="Malzeme Bilgileri Güncelle"
        bodyStyle={{ padding: 24 }}
        width={500}
        onClose={() => setUpdateFormVisibility(false)}
        visible={updateFormVisibility}
      >
        <MaterialUpdateForm
          data={updateFormData}
          onSuccess={onUpdateMaterialSuccess}
        />
      </Drawer>
    </>
  );
};

export default MaterialList;
